import { memo } from 'react';

import type { LbPart } from '../../types';

const Poll = ({ part: { data } }: { part: LbPart }) => (
  <div>
    <div>Poll</div>
    <div className='lb-composer-wrap' dangerouslySetInnerHTML={{ __html: data.Text }} />
  </div>
);

export default memo(Poll);
